function ResetStore() {
  return {
    type: 'RESET_STORE',
  };
}

export default ResetStore;
